import { render } from "./InfoPanel.vue?vue&type=template&id=51012b61&scoped=true"
import script from "./InfoPanel.vue?vue&type=script&lang=js"
export * from "./InfoPanel.vue?vue&type=script&lang=js"

import "./InfoPanel.vue?vue&type=style&index=0&id=51012b61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51012b61"]])

export default __exports__